module.exports = __webpack_public_path__ + "static/media/mattvirus.071969d5.jpg";